import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { OpportunityRequestI } from 'types';

interface Props {
  opportunityRequest: OpportunityRequestI | null | undefined;
}

/**
 * Shows the current opportunity request status to the employee.
 * Only renders for pending, approved, and rejected statuses.
 */
export default function OpportunityStatusBanner({ opportunityRequest }: Props) {
  if (!opportunityRequest) return null;

  const { status, comment } = opportunityRequest;

  if (status === 'approved') {
    return (
      <Box sx={{ px: 1 }}>
        <Typography variant="body2" color="text.primary" align="center" sx={{ fontWeight: 600, lineHeight: 1.5 }}>
          Solicitud aprobada
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ lineHeight: 1.5 }}>
          Puedes volver a intentarlo
        </Typography>
      </Box>
    );
  }

  if (status === 'pending') {
    return (
      <Box sx={{ px: 1 }}>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ lineHeight: 1.5 }}>
          Solicitud enviada — en revisión
        </Typography>
      </Box>
    );
  }

  if (status === 'rejected') {
    return (
      <Box sx={{ px: 1 }}>
        <Typography variant="body2" color="error.main" align="center" sx={{ lineHeight: 1.5 }}>
          Solicitud rechazada
        </Typography>
        {comment && (
          <Typography variant="body2" color="text.secondary" align="center" sx={{ lineHeight: 1.5 }}>
            {comment}
          </Typography>
        )}
      </Box>
    );
  }

  return null;
}
